export enum AppRoutesParams {
  Home = 'home',

  AdminContext = 'admin',
  ContextId = 'contextId',
  WebsiteId = 'websiteId',
  CategoryId = 'categoryId',
  CategoryGroupId = 'categoryGroupId',
  DmsFolderId = 'dmsFolderId',
  DmsFileId = 'dmsFileId',
  DmsContextId = 'dmsContextId',
  PageId = 'pageId',
  FaqId = 'faqId',
  ContentType = 'contentTypeInUrl',
  NewWebContentSubType = 'newWebContentSubType',
  EditWebContentSubType = 'editWebContentSubType',
  AddDocumentInWebContentId = 'addDocumentInWebContent',
  CopyCasovaRada = 'copyCasovaRada',
}

export enum ApplicationModule {
  Kontext = 'context',
  Stranky = 'stranky',
  Produkty = 'produkty',
  Dokumenty = 'dokumenty',
  Sprava = 'sprava',
  Faq = 'faq',
  Chyba = 'error',
  ChybaServeru = 'chyba-serveru',
}

export enum EditType {
  New = 'novy',
  Edit = 'upravit',
  Restore = 'obnovit',
  Template = 'sablona',
}

export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';
export const DEFAULT_DATETIME_SIMPLE_FORMAT = 'dd.MM.yyyy HH:mm';
export const DEFAULT_DATETIME_FORMAT = 'dd.MM.yyyy HH:mm:ss';
export const DEFAULT_DATE_REST_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_PAGE_LIMIT = 20;
export const DEFAULT_PAGE_OPTIONS = [5, 10, DEFAULT_PAGE_LIMIT];

export const DEFAULT_SORTING_TYPE = 'id';
export const DEFAULT_PAGE_AND_SORT = {
  start: 0,
  count: DEFAULT_PAGE_LIMIT,
  sortPage: DEFAULT_SORTING_TYPE,
};

export const SORTING_QUERY_PARAM = 'razeni';

export const ERROR_NOTIFICATION_SLOT_KEY = 'error';
export const DEFAULT_NOTIFICATION_SLOT_KEY = 'default';
export const JWT_TOKEN_KEY = 'id_token';
export const IS_LOGGED_IN = 'isLoggedIn';
export const LAST_ACTIVE_CONTEXT_ID = 'last_active_context_id';
export const CONTENT_EDITOR_SETTINGS = 'contentEditorSettings';

// helper context id if there are no contexts
export const NO_CONTEXTS_ID = -1;
export const DMS_API_URL = '/api/dms';
// export const BE_API_URL = '/api/redakcni-system';
// export const BE_API_URL = '/reza-api';
export const FAQ_API_URL = '/api/faq';
export const PRODUCTS_API_URL = '/api/katalog-produktu';
export const UDV_DATASTAT_DATA_URL = '/datastat/api/dotaz/data/vybery';
export const UDV_DATASTAT_CATALOG_URL = '/datastat/api/katalog/vybery';

export const DIALOG_BODY_CLASS = 'ngneat-dialog-hidden';

export const APP_NAVBAR_FIRST_ITEM_ID = 'pages-menu-item';

export const DEFAULT_SESSION_DIALOG_LIFE = 120;
export const DEFAULT_SESSION_TIME = 1800;
